export default "__VITE_ASSET__DQQoDO77__"